import DefaultFooter from "@/components/footer/DefaultFooter.component";
import Navbar from "@/components/navbar/Navbar.component";
import OrgManagementNavigation from "@/components/org-management/OrgManagementNavigation.component";
import { LoadingScreen } from "@/components/shared/LoadingScreen.component";
import { getOrg, IOrgState } from "@/models/org";
import { OrgModule } from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";
import style from "./OrgManagement.layout.module.scss";

@Component({ name: "OrgManagement" })
export default class OrgManagement extends Vue {
  get routerOrgId() {
    return this.$route.params.orgId;
  }

  get storeOrgId() {
    return OrgModule.id;
  }

  get isLoading() {
    return OrgModule.isLoading;
  }

  @Watch("routerOrgId", { immediate: true }) async onRouterOrgIdChange() {
    if (
      this.routerOrgId &&
      this.routerOrgId !== this.storeOrgId &&
      !this.isLoading
    ) {
      OrgModule.handleOrgLoadingStarted();
      const orgData: IOrgState = await getOrg(this.routerOrgId);
      OrgModule.handleQueryResponse(orgData);
    }
  }

  render() {
    return (
      <div class="shared-layout">
        <div class={style.container}>
          <Navbar
            scopedSlots={{
              secondaryNavbar: ({ onLinkClick }) => (
                <OrgManagementNavigation onLinkClick={onLinkClick} />
              ),
            }}
            showSecondaryNav={true}
          />
          <div class="content">
            {!this.isLoading && <router-view />}
            {this.isLoading && <LoadingScreen />}
          </div>
        </div>
        <DefaultFooter />
      </div>
    );
  }
}
